import axios, { AxiosInstance } from 'axios';

export const axiosAjax = ((): AxiosInstance => axios.create({
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With':'XMLHttpRequest',
  }
}))();

axios.interceptors.response.use((response) => {
  if(response.status === 401 || response.data.code === 141) {
    localStorage.clear()
    sessionStorage.clear()
    return Promise.reject('Unauthorized');
  }
  return response
}, (error) => {
  return Promise.reject(error.message);
})

export * from 'axios';
